import { StyleSheet } from 'react-native';
import theme from 'shared/styles/theme';
import { Maybe } from 'shared/utils/types';

export interface Steps {
  length: number;
}

export const calculateProgressFill = (
  currentStep: number,
  trackerType: 'SIMPLE' | 'COMPLEX',
  progressValue: number,
  steps: Steps[],
  totalLength,
) => {
  if (trackerType === 'SIMPLE') {
    return progressValue * 100;
  }

  const lengthUpToCurrentStep = steps
    ?.slice(0, currentStep)
    .reduce((acc, step) => acc + step.length, 0);
  const progressFill = Math.round((lengthUpToCurrentStep / totalLength) * 100);
  return progressFill;
};

export const getSeparatorPosition = (separatorPosition: number) =>
  StyleSheet.create({
    separatorPosition: {
      left: `${separatorPosition}%`,
    },
  });

export const getColorFiller = (color: Maybe<string>) => {
  if (color) {
    return StyleSheet.create({
      fillColor: {
        backgroundColor: color,
      },
    });
  }
  return StyleSheet.create({
    fillColor: {
      backgroundColor: theme.color.expressive.mint,
    },
  });
};

export const getBackgroundColor = (
  isSimpleTracker: boolean,
  backgroundColor: string | undefined,
) => {
  if (backgroundColor) {
    const styles = StyleSheet.create({
      dynamicBackgroundColor: {
        backgroundColor: backgroundColor,
      },
    });
    return styles.dynamicBackgroundColor;
  }
  if (isSimpleTracker) {
    return styles.simpleBgColor;
  }
  return styles.complexBgColor;
};

const styles = StyleSheet.create({
  complexBgColor: { backgroundColor: theme.color.background.tertiary },
  simpleBgColor: { backgroundColor: theme.color.background.primary },
});
